import React, { Component, } from 'react';
import { object, func, string, } from 'prop-types';
import { Helmet, } from 'react-helmet';
import { Switch, Route, } from 'react-router-dom';
import keys from 'lodash/keys';
import { connect, } from 'react-redux';

import TabBar from '../../components/TabBar';
import FundTable from './components/FundTable';
import DescriptionTable from './components/DescriptionTable';

import fetchPageApi from './actions/fetchPageApi';

export class Adjustment extends Component {
  static propTypes = {
    match: object.isRequired,
    fetchPageApi: func.isRequired,
    token: string.isRequired,
    company: string.isRequired,
    adjustment: object.isRequired,
    history: object.isRequired,
  }
  static defaultProps = {}
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const {
      match,
      fetchPageApi,
      token,
      adjustment,
      company,
    } = this.props;
    const {
      year,
      month,
    } = match.params;
    if (!adjustment[year] || !adjustment[year][month]) {
      fetchPageApi(company, year, month, token);
    }
  }
  render() {
    const { adjustment, match, } = this.props;
    const { projectId, year, month, } = match.params;
    if (!adjustment[year] || !adjustment[year][month]) {
      return null;
    }
    const adjData = adjustment[year][month];
    const tabs = keys(adjData).map(tab => ({
      name: tab.toUpperCase(),
      url: `${year}/${month}/adjustment/${tab}`,
      key: tab,
    }));
    const perfReports = keys(adjData);
    if (!this.state.initTab) {
      this.props.history.replace(`/${projectId}/${tabs[0].url}`);
      this.setState({ initTab: true, });
    }
    return (
      <div>
        <Helmet>
          <title>月報-本月投資組合調整</title>
        </Helmet>
        <TabBar
          tabs={ tabs }
        />
        <Switch>
          {
            perfReports.map(type => (
              <Route
                key={ type }
                path={ `/${projectId}/${year}/${month}/adjustment/${type}` }
                render={
                  () => (
                    <div>
                      <FundTable
                        data={ adjData[type].funds }
                        rebalance={ adjData[type].rebalance }
                        footnote={ adjData[type].footnote && adjData[type].footnote.funds }
                      />
                      <DescriptionTable
                        data={ adjData[type].desc }
                        footnote={ adjData[type].footnote && adjData[type].footnote.desc }
                      />
                    </div>
                  )
                }
              />
            ))
          }
        </Switch>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    adjustment: state.adjustment,
    token: state.appState.userToken,
    company: state.appState.company,
  };
}

const dispatchObj = {
  fetchPageApi,
};

export default connect(mapStateToProps, dispatchObj)(Adjustment);




// WEBPACK FOOTER //
// ./src/scenes/Adjustment/index.js